import * as types from './types';
import initialState from './initial-state';

export default function aiAssistantReducer(state = initialState, action) {
  switch (action.type) {
    case types.TOGGLE_SIDEBAR:
      return {
        ...state,
        isCollapsed: !state.isCollapsed,
        isVisible: true
      };

    case types.SET_SIDEBAR_VISIBLE:
      return {
        ...state,
        isVisible: action.payload
      };

    case types.SET_SIDEBAR_COLLAPSED:
      return {
        ...state,
        isCollapsed: action.payload
      };

    case types.UPDATE_CONTEXT:
      return {
        ...state,
        context: {
          ...state.context,
          ...action.payload
        }
      };

    case types.ADD_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload]
      };

    case types.UPDATE_MESSAGE:
      return {
        ...state,
        messages: state.messages.map(msg =>
          msg.id === action.payload.messageId
            ? { ...msg, ...action.payload.updates }
            : msg
        )
      };

    case types.CLEAR_MESSAGES:
      return {
        ...state,
        messages: []
      };

    case types.SET_CONVERSATION_ID:
      return {
        ...state,
        conversationId: action.payload
      };

    case types.SET_TYPING:
      return {
        ...state,
        isTyping: action.payload
      };

    case types.SET_PENDING_ACTION:
      return {
        ...state,
        pendingAction: action.payload
      };

    case types.CLEAR_PENDING_ACTION:
      return {
        ...state,
        pendingAction: null
      };

    case types.SEND_MESSAGE_REQUEST:
      return {
        ...state,
        error: null
      };

    case types.SEND_MESSAGE_FAILURE:
      return {
        ...state,
        error: action.payload,
        isTyping: false
      };

    case types.EXECUTE_ACTION_REQUEST:
      return {
        ...state,
        error: null
      };

    case types.EXECUTE_ACTION_FAILURE:
      return {
        ...state,
        error: action.payload
      };

    case types.LOAD_CONVERSATION_SUCCESS:
      return {
        ...state,
        conversationId: action.payload.id,
        messages: action.payload.messages || []
      };

    case types.SET_ERROR:
      return {
        ...state,
        error: action.payload
      };

    case types.CLEAR_ERROR:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
}
